export default {
    remoteFile: {
        label: 'Select from your repository',
        placeholder: 'Select file',
    },
    upload: 'Upload from local',
    save: 'Save to repository',
};
